import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core'
import { FormGroupDirective, NgControl } from '@angular/forms'

@Component({
    selector: 'superflex-input-number',
    template:`
        <label for="controltext"> {{ label }} <span *ngIf="ngControl.control.errors?.required" style="font-weight: 900;">*</span> </label>
        <p-inputNumber
            [formControl]='ngControl.control'
            [placeholder]="placeholder"
            [mode]="mode"
            [autocomplete]="autocomplete"
            [minFractionDigits]="minFractionDigits"
            [maxFractionDigits]="maxFractionDigits"
            [maxlength]="maxlength"
            [useGrouping]="useGrouping"
            [currency]="currency"
            [locale]="locale"
            >
        </p-inputNumber>
        <app-error [input]="ngControl.control" [form]="form" ></app-error>
    `,
    host: {'class': 'p-field'}
})
export class InputNumberComponent implements OnInit {

    @Input() isDisabled: boolean = false
    @Input() maxlength: number = null
    @Input() label: string = ''
    @Input() minFractionDigits: number = null
    @Input() maxFractionDigits: number = null

    @Input() mode = 'decimal';
    @Input() currency ="USD";
    @Input() locale = "en-US";
    @Input() useGrouping = "true";
    @Input() autocomplete = "false";

    @Input() placeholder = '';
    @ViewChild('rb') inputViewChild: ElementRef;

    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    public checked: boolean;
    public focused: boolean;

    form!: FormGroupDirective
    constructor(@Self() @Optional() public ngControl: NgControl, private rootFormGroup: FormGroupDirective) {

        this.form = this.rootFormGroup;
        if (this.ngControl) {
            ngControl.valueAccessor = this
        }
    }

    ngOnInit(): void {/** */}

    writeValue(value: any): void {/** */}
    registerOnChange(fn: any): void {/** */}
    registerOnTouched(fn: any): void {/** */}
    setDisabledState?(isDisabled: boolean): void {/** */}

    onInputFocus(event): void {
        this.focused = true;
        this.onFocus.emit(event);
    }

    onInputBlur(event): void {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }

    onModelTouched = () => {
        this.ngControl.control.markAsTouched();
    };

    focus(): void {
        this.inputViewChild.nativeElement.focus();
    }

    ngOnDestroy(): void {
        // this.registry.remove(this);
    }

    getPlaceholderPrefix(): string {
        return this.isDisabled ? '' : 'FORM_ERRORS.placeholder';
    }

}
